
<div class="floating-pill">
<!--    <div class="btn-group btn-group-lg" role="group">-->
<!--        <button type="button" class="btn" (click)="orderCreate('quote')">-->
<!--            <i class="fa fa-calculator fa-fw"></i>-->
<!--            Quote-->
<!--        </button>-->
<!--        <button type="button" class="btn" (click)="orderCreate('order')">-->
<!--            <i class="fa fa-cart-plus fa-fw"></i>-->
<!--            Order-->
<!--        </button>-->
<!--    </div>-->
<app-speed-dial-fab md-direction="bottom"  class="speed-dial-container-left"></app-speed-dial-fab>

    <!-- <div class="btn-group btn-group-lg" role="group">
        <button type="button" class="btn btn-info" (click)="orderCreate('order')">
            <i class="fa fa-cart-plus fa-fw"></i>
            Order
        </button>
    </div> -->

</div>
